<template>
  <a-popover v-model="visible" v-a11y-tab trigger="click" :placement="placement">
    <p slot="content" class="text">{{ message }}</p>
    <div class="icon" :class="iconClass">?</div>
  </a-popover>
</template>

<script>
export default {
  props: {
    message: String,
    placement: String,
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    iconClass() {
      return {
        active: this.visible,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 21px;
  width: 21px;
  background: $light-grey;
  color: $grey;
  border-radius: 50%;
  cursor: pointer;
  font-size: $font-size-small;
  border: 1px solid $grey;
}
.active {
  background: $white;
  border: 1px solid $blue;
  color: $blue;
}
.text {
  width: 300px;
  color: $grey;
  font-size: $font-size-small;
  letter-spacing: 0.11px;
  line-height: 16px;
}
</style>
